import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_URL } from '../Utils/api';

export const useNotifications = (token, userId) => {
  return useQuery({
    queryKey: ['notifications', userId],
    queryFn: async () => {
      if (!token || !userId) return [];
      const res = await axios.get(`${API_URL}/user/notifs/${userId}`, {
        headers: { Authorization: `Bearer${token}` },
      });
      return res.data || [];
    },
    enabled: !!token && !!userId,
    staleTime: 1000 * 30, 
  });
};
